export default __webpack_public_path__ + "static/media/2-cloudxier-PLN-mockup01.0d4b18c6.jpg";